import React from 'react';
import { useFormState } from 'react-final-form';

import SectionSeparator from '@dashboard/components/SectionSeparator';
import { Alert, Button } from '@mui/material';

export default function UnsavedTriggersSectionAlert() {
  const fState = useFormState();
  if (!fState.dirtyFields.triggers) {
    return null;
  }
  return (
    <>
      <SectionSeparator />
      <Alert variant="outlined" severity="warning" action={<Button type="submit">Save</Button>}>
        Your trigger has changed. Save this workflow before setting up test data.
      </Alert>
    </>
  );
}
